import AdminDashboardBox from '../../components/admin/AdminDashboardBox'
import AdminLayout from '../../components/layout/AdminLayout'

const Dashboard = () => {
  return (
    <AdminLayout>
      <AdminDashboardBox />
    </AdminLayout>
  )
}

export default Dashboard
